export enum FeatureFlagType {
  TextDatabaseProperty = 'database-property-text',
  LongTextDatabaseProperty = 'database-property-long-text',
  NumberDatabaseProperty = 'database-property-number',
  BooleanDatabaseProperty = 'database-property-boolean',
  DropdownDatabaseProperty = 'database-property-dropdown',
  DateDatabaseProperty = 'database-property-date',
  TimeDatabaseProperty = 'database-property-time',
  DateRangeDatabaseProperty = 'database-property-date-range',
  TeleportDatabaseProperty = 'database-property-teleport',
  ReverseRelationDatabaseProperty = 'database-property-reverse-relation',
  RelationDatabaseProperty = 'database-property-relation',
  FormulaDatabaseProperty = 'database-property-formula',
  PhoneDatabaseProperty = 'database-property-phone',
  LocationDatabaseProperty = 'database-property-location',
  MailDatabaseProperty = 'database-property-mail',
  LinkDatabaseProperty = 'database-property-link',
  PeopleDatabaseProperty = 'database-property-people',
  RatingDatabaseProperty = 'database-property-rating',
  CommentsDatabaseProperty = 'database-property-comments',
  FilesDatabaseProperty = 'database-property-files',
  StatusDatabaseProperty = 'database-property-status',
  RowIdDatabaseProperty = 'database-property-id',
  AutoIdDatabaseProperty = 'database-property-auto-id',
  RandomIdDatabaseProperty = 'database-property-random-id',
  TimeTrackerDatabaseProperty = 'database-property-time-tracker',
  CreatedAtDatabaseProperty = 'database-property-created-at',
  UpdatedAtDatabaseProperty = 'database-property-updated-at',
  ChecklistDatabaseProperty = 'database-property-checklist',
  VoteDatabaseProperty = 'database-property-vote',

  TableDatabaseView = 'database-view-table',
  MapDatabaseView = 'database-view-map',
  FormDatabaseView = 'database-view-form',
  TimelineDatabaseView = 'database-view-timeline',
  CalendarDatabaseView = 'database-view-calendar',
  KanbanDatabaseView = 'database-view-kanban',
  IFrameDatabaseView = 'database-view-iframe',
  GanttDatabaseView = 'database-view-gantt',

  ChartDashboardItem = 'dashboard-item-chart',
  DatabaseViewDashboardItem = 'dashboard-item-database-view',
  TimeTrackerDashboardItem = 'dashboard-item-time-tracer',
  MapDashboardItem = 'dashboard-item-map',
  AggregatedDatabaseItemListDashboardItem = 'dashboard-item-aggregated-item-list',
  IndicatorDashboardItem = 'dashboard-item-indicator',

  WorkspaceDocuments = 'workspace-documents',
  WorkspaceConversations = 'workspace-conversations',
  WorkspaceCallRooms = 'workspace-call-rooms',
  WorkspaceTemplates = 'workspace-templates',
  WorkspaceSpaces = 'workspace-spaces',
  WorkspaceApps = 'workspace-apps',
  WorkspaceAgents = 'workspace-agents',
  EmailSupport = 'email-support',
  PrioritySupport = 'priority-support',
  DedicatedSupport = 'dedicated-support',
  Sso = 'sso',
}
